import { render, staticRenderFns } from "./OverlaySidebarCart.vue?vue&type=template&id=35041555&"
import script from "./OverlaySidebarCart.vue?vue&type=script&lang=js&"
export * from "./OverlaySidebarCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35041555')) {
      api.createRecord('35041555', component.options)
    } else {
      api.reload('35041555', component.options)
    }
    module.hot.accept("./OverlaySidebarCart.vue?vue&type=template&id=35041555&", function () {
      api.rerender('35041555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlaySidebarCart.vue"
export default component.exports